import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import api from "./services/api";

import { AUTH_LOGOUT } from "./store/actions/auth.js";

import "./quasar";
Vue.prototype.$axios = axios;

Vue.prototype.$http = api;
api.defaults.timeout = 10000;

Vue.config.productionTip = false;

api.interceptors.request.use(
  config => {
    const token = JSON.parse(localStorage.getItem("access_token")).token;
    if (token) {
      config.headers.common["Authorization"] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
          break;

        case 401:
          alert("session expired");
          store.dispatch(AUTH_LOGOUT).then(() => router.push("/login"));
          break;
        case 403:
          break;
        case 404:
          break;
        case 502:
          setTimeout(() => {
            router.replace({
              path: "/login",
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
      }
      return Promise.reject(error.response);
    }
  }
);

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: function() {
    if (localStorage.getItem("user_data")) {
      store.dispatch(
        "sidebar/setMenu",
        JSON.parse(localStorage.getItem("user_data")).menuitems
      );
    }
  }
}).$mount("#app");
